import BaseAuth from 'nast-auth'
/**
 *
 */
export default class NastAuth extends BaseAuth {
  /**
   * Безопасный выход пользователя.
   * @param {boolean} redirect - нужно ли выполнять переход к странице логина (по умолчанию true).
   */
  logout(redirect = true) {
    if (typeof super.logout === 'function') {
      super.logout(false);
    }

    try {
      localStorage.removeItem('auth');
    } catch (e) {
      console.error('[Auth] Не удалось удалить auth из localStorage', e);
    }

    if (redirect) {
      try {
        const router = this._router || (this._app?.router?.router?.());
        if (router) {
          const loginRouteName = this._config ? this._config('loginRoute') || 'login' : 'login';
          if (router.currentRoute?.name !== loginRouteName) {
            router.replace({ name: loginRouteName });
          }
          return;
        }
      } catch (e) {
        console.error('[Auth] Не удалось выполнить redirect через router', e);
      }

      if (typeof window !== 'undefined') {
        window.location.replace('/login');
      }
    }
  }
}
